<template>
    <nav class="d-flex">
        <ul class="pagination">
            <li v-for="page in pagerContent.pages" :key="page.text" class="page-item" v-bind:class="{ 'active' : page.currentPage }" v-on:click="search(page.urlContent.mfrId, page.urlContent.queryText, page.urlContent.page)">
                <a class="page-link">
                    {{page.text}}
                </a>
            </li>
        </ul>
    </nav>
</template>

<script>
    export default {
        name: 'SearchPager',
        props: {
            pagerContent: {
                type: Object,
                default: () => {
                    return {
                        queryText: "",
                        mfrId: "",
                        url: "",
                        pages: [],
                        resultCount:""
                    }
                }
            }
        },
        methods: {
            search(mfrId, queryText, pageId) {
                this.$root.$emit('search_parts', mfrId, queryText, pageId);
            }
        }
    }
</script>

<style>
    .page-item.active .page-link {
        background-color: var(--ul-red);
        border-color: var(--ul-red);
    }
    .page-item {
        cursor: pointer;
    }
</style>